export const validateEmail = (email: string): boolean => /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/.test(email)

export const validatePhone = (phone: string): boolean => /(\(\d{2}\)\s)(\d{4,5}-\d{4})/.test(phone)

export const isEmpty = (string: string): boolean => string === ''

export const validateNumberField = (value: string) => /^(?=.)(([0-9]*)(,([0-9]+))?)$/.test(value)

export const validateHour = (value: string) => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)
